import * as company from 'services/company';

export const COMPANYINFO_SEL = 'COMPANYINFO_SEL';
export const STAFF_CHECK_ADD = 'STAFF_CHECK_ADD';
export const STAFF_LINK_ADD = 'STAFF_LINK_ADD';
export const STAFFSIGNUP_STATUS_SEL = 'STAFFSIGNUP_STATUS_SEL';
export const STAFF_REQUESTED_SEL = 'STAFF_REQUESTED_SEL';
export const STAFF_RESEND_SEL = 'STAFF_RESEND_SEL';
export const STAFF_CANCEL_DEL = 'STAFF_CANCEL_DEL';
export const STAFF_BULK_MOD = 'STAFF_BULK_MOD';
export const STAFF_ACT = 'STAFF_ACT';
export const STAFF_DEL = 'STAFF_DEL';
export const STAFF_PWD_CHANGE = 'STAFF_PWD_CHANGE';
export const STAFF_EXCEL_CHECK = 'STAFF_EXCEL_CHECK';
export const STAFF_EXCEL_UPLOAD = 'STAFF_EXCEL_UPLOAD';
export const POSITION_SEL = 'POSITION_SEL';
export const POSITION_ADD = 'POSITION_ADD';
export const POSITION_MOD = 'POSITION_MOD';
export const POSITION_DEL = 'POSITION_DEL';
export const DIVISION_SORT_MOD = 'DIVISION_SORT_MOD';
export const DIVISION_BUDGET = 'DIVISION_BUDGET';
export const DIVISION_ADD_BUDGET = 'DIVISION_ADD_BUDGET';
export const DIVISION_MOD_BUDGET = 'DIVISION_MOD_BUDGET';
export const DIVISION_DEL_BUDGET = 'DIVISION_DEL_BUDGET';
export const DIVISION_SEL_BUDGET = 'DIVISION_SEL_BUDGET';
export const DIVISION_ADD = 'DIVISION_ADD';
export const DIVISION_DEL = 'DIVISION_DEL';
export const DIVISION_USER_COUNT = 'DIVISION_USER_COUNT';
export const NOTICE_LIST = 'NOTICE_LIST';
export const NOTICE_ADD = 'NOTICE_ADD';
export const NOTICE_SEL = 'NOTICE_SEL';
export const NOTICE_MOD = 'NOTICE_MOD';
export const PUSH_LIST = 'PUSH_LIST';
export const PUSH_ADD = 'PUSH_ADD';
export const LOG_OUT = 'LOG_OUT';
export const LOG_OUT_STEP_TWO = 'LOG_OUT_STEP_TWO';
export const CHANGE_INFO_SEL = 'CHANGE_INFO_SEL';
export const CANCEL_RESERVE = 'CANCEL_RESERVE';
export const LOGIN_HISTORY = 'LOGIN_HISTORY';
export const MY_PWD_CHANGE = 'MY_PWD_CHANGE';

// 회사 정보 조회
export const CompanyInfoSel = (comId) => ({
  type: COMPANYINFO_SEL,
  payload: {
    promise: company.CompanyInfoSel(comId)
  }
});

// 사용자 회원가입 목록 추가
export const CheckStaffList = (params) => ({
  type: STAFF_CHECK_ADD,
  payload: {
    promise: company.CheckStaffList(params)
  }
});

// 사용자 회원가입 링크전송
export const StaffLinkAdd = (params) => ({
  type: STAFF_LINK_ADD,
  payload: {
    promise: company.StaffLinkAdd(params)
  }
});

// 사용자 회원가입 상태코드
export const SignupStatus = () => ({
  type: STAFFSIGNUP_STATUS_SEL,
  payload: {
    promise: company.SignupStatus()
  }
});

// 사용자 회원가입 요청내역
export const RequestedList = (params) => ({
  type: STAFF_REQUESTED_SEL,
  payload: {
    promise: company.RequestedList(params)
  }
});

// 사용자 회원가입 링크 재전송
export const ResendLink = (params) => ({
  type: STAFF_RESEND_SEL,
  payload: {
    promise: company.ResendLink(params)
  }
});

// 사용자 회원가입 링크 취소
export const CancelLink = (params) => ({
  type: STAFF_CANCEL_DEL,
  payload: {
    promise: company.CancelLink(params)
  }
});

// 사용자 추가
export const StaffAct = (method, params) => ({
  type: STAFF_ACT,
  payload: {
    promise: company.StaffAct(method, params)
  }
});

// 사용자 퇴사
export const StaffDel = (params) => ({
  type: STAFF_DEL,
  payload: {
    promise: company.StaffDel(params)
  }
});

// 사용자 비밀번호 변경 (초기화)
export const StaffPwdChange = (params) => ({
  type: STAFF_PWD_CHANGE,
  payload: {
    promise: company.StaffPwdChange(params)
  }
});

// 사용자 비밀번호 변경
export const MyPwdChange = (params) => ({
  type: MY_PWD_CHANGE,
  payload: {
    promise: company.MyPwdChange(params)
  }
});

// 사용자 목록 엑셀파일로 관리 > 업로드 체크
export const StaffExcelCheck = (params) => ({
  type: STAFF_EXCEL_CHECK,
  payload: {
    promise: company.StaffExcelCheck(params)
  }
});

// 사용자 목록 엑셀파일로 관리 > 업로드
export const StaffExcelUpload = (params) => ({
  type: STAFF_EXCEL_UPLOAD,
  payload: {
    promise: company.StaffExcelUpload(params)
  }
});

// 직위 조회
export const PositionSel = () => ({
  type: POSITION_SEL,
  payload: {
    promise: company.PositionSel()
  }
});

// 직위 등록
export const PositionAdd = (params) => ({
  type: POSITION_ADD,
  payload: {
    promise: company.PositionAdd(params)
  }
});

// 직위 수정
export const PositionMod = (params) => ({
  type: POSITION_MOD,
  payload: {
    promise: company.PositionMod(params)
  }
});

// 직위 삭제
export const PositionDel = (params) => ({
  type: POSITION_DEL,
  payload: {
    promise: company.PositionDel(params)
  }
});

// 부서 재정렬
export const DivisionSortMod = (params) => ({
  type: DIVISION_SORT_MOD,
  payload: {
    promise: company.DivisionSortMod(params)
  }
});

// 부서 등록
export const DivisionAdd = (params) => ({
  type: DIVISION_ADD,
  payload: {
    promise: company.DivisionAdd(params)
  }
});

// 부서 삭제
export const DivisionDel = (params) => ({
  type: DIVISION_DEL,
  payload: {
    promise: company.DivisionDel(params)
  }
});

// 부서별 예산 리스트
export const DivisionBudget = (orgCode, params) => ({
  type: DIVISION_BUDGET,
  payload: {
    promise: company.DivisionBudget(orgCode, params)
  }
});

// 부서별 예산 항목 등록
export const DivisionBudgetAdd = (orgCode, params) => ({
  type: DIVISION_ADD_BUDGET,
  payload: {
    promise: company.DivisionBudgetAdd(orgCode, params)
  }
});

// 부서별 예산 항목 수정
export const DivisionBudgetMod = (budgetIdx, params) => ({
  type: DIVISION_MOD_BUDGET,
  payload: {
    promise: company.DivisionBudgetMod(budgetIdx, params)
  }
});

// 부서별 예산 항목 삭제
export const DivisionBudgetDel = (budgetIdx, params) => ({
  type: DIVISION_DEL_BUDGET,
  payload: {
    promise: company.DivisionBudgetDel(budgetIdx, params)
  }
});

// 부서별 예산 항목 사용내역
export const DivisionBudgetSel = (budgetIdx, params) => ({
  type: DIVISION_SEL_BUDGET,
  payload: {
    promise: company.DivisionBudgetSel(budgetIdx, params)
  }
});

// 회사 공지사항 목록
export const NoticeList = (params) => ({
  type: NOTICE_LIST,
  payload: {
    promise: company.NoticeList(params)
  }
});

// 회사 공지사항 등록
export const NoticeAdd = (params) => ({
  type: NOTICE_ADD,
  payload: {
    promise: company.NoticeAdd(params)
  }
});

// 회사 공지사항 상세
export const NoticeDtl = (id) => ({
  type: NOTICE_SEL,
  payload: {
    promise: company.NoticeDtl(id)
  }
});

// 회사 공지사항 수정
export const NoticeMod = (id, params) => ({
  type: NOTICE_MOD,
  payload: {
    promise: company.NoticeMod(id, params)
  }
});

// 푸쉬 목록
export const PushMessageList = (params) => ({
  type: PUSH_LIST,
  payload: {
    promise: company.PushMessageList(params)
  }
});

// 푸쉬 등록
export const PushMessageAdd = (params) => ({
  type: PUSH_ADD,
  payload: {
    promise: company.PushMessageAdd(params)
  }
});

// 사용자 변경(부서, 직위, 그룹별) 대량 변경
export const StaffBulkMod = (params) => ({
  type: STAFF_BULK_MOD,
  payload: {
    promise: company.StaffBulkMod(params)
  }
});

// 부서별 사용자 수
export const DivisionUserCnt = (params) => ({
  type: DIVISION_USER_COUNT,
  payload: {
    promise: company.DivisionUserCnt(params)
  }
});

// 강제 로그아웃
export const Logout = (id, params) => ({
  type: LOG_OUT,
  payload: {
    promise: company.Logout(id, params)
  }
});
export const LogoutStepTwo = (params) => ({
  type: LOG_OUT_STEP_TWO,
  payload: {
    promise: company.LogoutStepTwo(params)
  }
});

// 사용자관리 정보변경 내역
export const ChangeInfoSel = (params) => ({
  type: CHANGE_INFO_SEL,
  payload: {
    promise: company.ChangeInfoSel(params)
  }
});

// 사용자 관리 정보 변경 예약 취소
export const CancelReserve = (idx, params) => ({
  type: CANCEL_RESERVE,
  payload: {
    promise: company.CancelReserve(idx, params)
  }
});

// 로그인 이력 조회
export const loginHistory = (params) => ({
  type: LOGIN_HISTORY,
  payload: {
    promise: company.loginHistory(params)
  }
});
